import { css } from '@emotion/react';
import { theme } from '../../theme/theme';

export const keyValueListStyle = css`
  margin: 0;
  font-size: ${theme.fontSize.md}px;

  > div {
    display: flex;
    gap: ${theme.space.md}px;
    padding: ${theme.space.sm}px 0;
  }

  > div:not(:first-of-type) {
    border-top: 1px solid ${theme.color.border};
  }

  dt {
    flex: 0 0 8em;
    font-size: ${theme.fontSize.sm}px;
    color: ${theme.color.textMuted};
  }

  dd {
    margin: 0;
    word-break: break-all;
  }
`;
